import React from 'react';
import Hero from '../components/Hero';
import PortfolioCarousel from '../components/PortfolioCarousel';
import VisionSection from '../components/VisionSection';
import ServicesSection from '../components/ServicesSection';
import StatsSection from '../components/StatsSection';
// HIDDEN: Team section temporarily hidden - uncomment to restore
// import TeamSection from '../components/TeamSection';
import ClientReviews from '../components/ClientReviews';
import PartnersSection from '../components/PartnersSection';

const Home = () => {
  return (
    <main className="home-page">
      <Hero />
      <PortfolioCarousel />
      <VisionSection />
      <ServicesSection />
      <StatsSection />
      {/* HIDDEN: Team section temporarily hidden - uncomment to restore */}
      {/* <TeamSection /> */}
      <ClientReviews />
      <PartnersSection />
    </main>
  );
};

export default Home;
